import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid2 as Grid,
  Radio,
  Stack,
  Typography,
} from "@mui/material";
import {
  createProfileReq,
  getUpdatedDetailsReq,
} from "../../../../redux/specialist-slices/auth.slice";
import {
  requiredFields,
  specializationComponents,
  validationField,
} from "./data";
import InputField1 from "../../../../components/ui/InputField1";
import SelectInput from "../../../../components/ui/SelectInput";
import { validateNumber } from "../../../../utils/velidations";
import FileInput from "../../../../components/ui/FileInput";
import { useDispatch, useSelector } from "react-redux";
import { currencies } from "../data";
import { red } from "@mui/material/colors";
import ContactInfo from "./ContactInfo";
import { useState, useRef } from "react";
import Address from "./Address";
import RadioInput1 from "../../../../components/ui/RadioBtn";


let persistedFormData = null;
let persistedFiles = null;

function Profile({ handleChange }) {
  const currency = useRef("");
  const timezone = useRef("");
  const countryRef = useRef("");
  const stateRef = useRef("");
  const cityRef = useRef("");
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const { specialist } = useSelector((state) => state.specialistSlice);

  const getInitialFiles = () => {
    if (persistedFiles) {
      return persistedFiles;
    }
    return {
      profilePhoto: specialist?.profile?.profilePhoto || [],
      clientDemographics: specialist?.profile?.clientDemographics || [],
      specializationArea: specialist?.profile?.specializationArea || [],
      additionalCertificates: specialist?.profile?.additionalCertificates || [],
      ceritificationDocuments:
        specialist?.profile?.ceritificationDocuments || [],
      specializationCertificate:
        specialist?.profile?.specializationCertificate || [],
    };
  };

  const files = useRef(getInitialFiles());
  const formRef = useRef(null);

  const handleSpecializationArea = (_, value) => {
    files.current.specializationArea = value;
  };

  const handleBack = () => {
    if (formRef.current) {
      const formData = new FormData(formRef.current);

      persistedFormData = {
        professionalBio: formData.get("professionalBio") || "",
        description: formData.get("description") || "",
        language: formData.get("language") || "",
        termsCheck: formData.get("termsCheck") === "on",
        currency: currency?.current?.value?.value || "",
        timeZone: timezone?.current?.value?.value || "",
        therapeuticMethods: formData.get("therapeuticMethods") || "",
        specializationAreaDescription:
          formData.get("specializationAreaDescription") || "",
        specializationCertificate:
          formData.get("specializationCertificate") || "",
        gender: formData.get("gender") || "",

        country: countryRef?.current?.value?.id || "",
        state: stateRef?.current?.value?.id || "",
        city: cityRef?.current?.value?.id || "",
        zip: formData.get("zip") || "",
      };

      persistedFiles = { ...files.current };


    }

    dispatch(getUpdatedDetailsReq()).then(() => {
      handleChange("background");
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = {};
    const form = new FormData(e.target);

    let formData = Object.fromEntries(form);

    formData.currency = currency?.current?.value?.value;
    formData.timeZone = timezone?.current?.value?.value;
    formData.country = countryRef?.current?.value?.name;
    formData.state = stateRef?.current?.value?.name;
    formData.city = cityRef?.current?.value?.name;


    formData = {
      ...files.current,
      ...formData,
    };
    formData.specializationArea = formData?.specializationArea?.map(
      ({ _id }) => _id
    );
    const validation = [
      ...requiredFields,
      ...(Array.isArray(validationField?.[specialist?.experties?.specializationId])
        ? validationField[specialist.experties.specializationId]
        : []),
    ];
    validation.forEach((field) => {
      if (!field.optional) {
        const value = formData[field.name];

        const isInvalid =
          value === undefined ||
          value === null ||
          (typeof value === "string" && value.trim() === "") ||
          (Array.isArray(value) && value.length === 0);

        if (isInvalid) {
          err[field.name] = true;
        } else {
          delete err[field.name];
        }
      }
    });

    if (formData.zip) {
      const zipClean = formData.zip.trim();
      const zipPattern = /^\d{5,6}$/;
      if (!zipPattern.test(zipClean)) {
        err.zip = "Zip code must be 5 or 6 digits";
      }
    }

    const filteredData = {};
    validation?.forEach(({ name }) => {
      filteredData[name] = formData[name];
    });
    setErrors(err);
    if (!Object.keys(err)?.length) {
      persistedFormData = null;
      persistedFiles = null;

      dispatch(createProfileReq(filteredData))
        .unwrap()
        .then(() => {
          handleChange("confirmation");
        })
        .catch(() => { });
    }
  };

  const getDefaultValue = (field, apiPath) => {
    if (persistedFormData?.[field]) {
      return persistedFormData[field];
    }
    return apiPath || "";
  };

  const getDefaultCheckbox = (field) => {
    if (persistedFormData && persistedFormData[field] !== undefined) {
      return persistedFormData[field];
    }
    return Boolean(specialist?.profile);
  };

  const SpecializationComponents =
    specializationComponents?.[specialist?.experties?.specializationId];

  return (
    <Box
      sx={{
        p: 3,
        border: "1px solid #3498db",
        borderTop: "none",
        borderRadius: "0 0 6px 6px",
      }}
    >
      <Typography
        mb={2}
        fontSize={36}
        component="h2"
        fontWeight="700"
        color="other.color1"
      >
        Create Your Professional Profile
      </Typography>
      <Typography
        mb={1.7}
        fontSize={24}
        component="h4"
        fontWeight="600"
        color="other.color1"
      >
        Help potential clients know you better by setting up your profile. Add
        your bio, photo, and the services you offer
      </Typography>

      <Grid
        container
        rowSpacing={2}
        columnSpacing={1}
        component="form"
        ref={formRef}
        onSubmit={handleSubmit}
      >
        <>
          <Grid size={12}>
            <InputField1
              type="textarea"
              errors={errors}
              name="professionalBio"
              label="Professional Bio *"
              errText="Please enter professional bio"
              defaultValue={getDefaultValue(
                "professionalBio",
                specialist?.profile?.professionalBio
              )}
              key={getDefaultValue(
                "professionalBio",
                specialist?.profile?.professionalBio
              )}
              placeholder="Share a bit about your background, experience, and what clients can expect when working with you."
            />
          </Grid>
          <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
            <FileInput
              files={files}
              errors={errors}
              name="profilePhoto"
              label="Profile Photo *"
              errText="Please upload profile photo"
              placeholderText="Upload a professional photo that represents you"
              defaultValue={
                files.current.profilePhoto?.length
                  ? files.current.profilePhoto
                  : specialist?.profile?.profilePhoto || []
              }
            />
          </Grid>
          <Grid size={12}>
            <InputField1
              type="textarea"
              errors={errors}
              name="description"
              label="Service Description *"
              errText="Please enter service description"
              defaultValue={getDefaultValue(
                "description",
                specialist?.profile?.description
              )}
              key={getDefaultValue(
                "description",
                specialist?.profile?.description
              )}
              placeholder="Describe the services you offer and what clients can expect."
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <SelectInput
              ref={currency}
              name="currency"
              label="Currency *"
              options={currencies}
              renderValueKey="name"
              select="Select type:-"
              varianttype="selectType1"
              selectLabel="Select currency"
              defaultValue={
                persistedFormData?.currency
                  ? currencies.find(
                    (c) => c.value === persistedFormData.currency
                  )
                  : specialist?.profile?.currency
                    ? currencies.find(
                      (c) => c.value === specialist.profile.currency
                    )
                    : undefined
              }
            />
            {errors?.currency && (
              <Typography mt={1} color={red["500"]}>
                Please select currency type
              </Typography>
            )}
          </Grid>
          {/* Identity (Gender) Radio Field */}
          <Grid size={{ xs: 12, md: 6 }}>

            <InputField1
              name="language"
              errors={errors}
              label="Languages Spoken *"
              errText="Please enter languages"
              defaultValue={getDefaultValue(
                "language",
                specialist?.profile?.language
              )}
              key={getDefaultValue("language", specialist?.profile?.language)}
              placeholder="List the languages you are fluent in."
            />

          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <RadioInput1
              name="gender"
              label="Identity (Gender) *"
              errors={errors}
              errText="Please select your identity"
              defaultValue={getDefaultValue("gender", specialist?.profile?.gender)}
            >
              <FormControlLabel value="male" control={<Radio size="small" />} label="Male" />
              <FormControlLabel value="female" control={<Radio size="small" />} label="Female" />
              <FormControlLabel value="others" control={<Radio size="small" />} label="Others" />
            </RadioInput1>
          </Grid>
        </>
        <Address
          errors={errors}
          persistedData={persistedFormData}
          countryRef={countryRef}
          stateRef={stateRef}
          cityRef={cityRef}
          timezone={timezone}
        />

        {specialist?.experties?.specializationId && <ContactInfo />}
        {!(specialist?.experties?.specializationId === "67d90056c2c4d5ab747f8b43" ||
          specialist?.experties?.specializationId === "695751a16eb048cf622268e5") &&
          (
            <SpecializationComponents
              errors={errors}
              files={files}
              onChangFun={handleSpecializationArea}
              persistedData={persistedFormData}
            />
          )}

        <>
          <Grid size={12}>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                color: "other.color1",
              }}
            >
              Terms & conditions *
            </Typography>
            <FormControlLabel
              label="I agree to the Terms & Conditions"
              control={
                <Checkbox
                  name="termsCheck"
                  defaultChecked={getDefaultCheckbox("termsCheck")}
                  key={`terms-${getDefaultCheckbox("termsCheck")}`}
                />
              }
            />
            {errors?.termsCheck && (
              <Typography mt={1} color={red["500"]}>
                Please accept Terms & Conditions
              </Typography>
            )}
          </Grid>
          <Grid size={12}>
            <Stack spacing={2} direction="row">
              <Button
                sx={{
                  py: 1.2,
                  minWidth: "110px",
                  justifyContent: "center",
                }}
                type="button"
                variant="contained"
                onClick={handleBack}
              >
                Back
              </Button>
              <Button
                sx={{
                  py: 1.2,
                  minWidth: "110px",
                  justifyContent: "center",
                }}
                type="submit"
                variant="contained"
              >
                Submit
              </Button>
            </Stack>
          </Grid>
        </>
      </Grid>
    </Box>
  );
}

export default Profile;
